import { QuestionnaireQuestion, QuestionnaireQuestionResponse, QuestionnaireResponse } from 'types/questionnaire';
import { apiSecureRequest } from '@utils/request';
import { AxiosResponse } from 'axios';

function suppress404(response: AxiosResponse): boolean {
	return response.status === 404;
}

export async function getQuestionnaireResponse(ignore404: boolean): Promise<QuestionnaireResponse> {
	const response = await apiSecureRequest.get(`/intake-response`, ignore404 ? { suppressToast: suppress404 } : {});
	return response.data;
}

export async function submitQuestionResponse(
	questionId: number,
	questionResponse: QuestionnaireQuestionResponse | undefined
): Promise<QuestionnaireQuestion> {
	const response = await apiSecureRequest.post(
		`/intake-response/question/${questionId}`,
		questionResponse
	);
	return response.data;
}
